import React from "react";
import "./index.scss";
import { imgCrop } from "packages/helpers";

export interface BannerPropsWrapper extends BannerProps {
  adBanners?: BannerProps[];
}

export interface BannerProps {
  sponsorLogoUrl?: string;
  imgDesktopURL?: string;
  imgMobileURL?: string;
  ctaAlignment?: "right" | "left";
  logoAlignment?: "right" | "left";
  heading?: string;
  subHeading?: string;
  gTagEventSponsor?: string;
  gTagEventCategory?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  link?: {
    url: string;
    name: string;
    id: number;
  };
  position?: string;
  desktopImageAnimated?: string;
  mobileImageAnimated?: string;
  imageUrls?: imgCrop[];
}

const Banner = ({
  sponsorLogoUrl,
  imgDesktopURL,
  imgMobileURL,
  ctaAlignment,
  logoAlignment,
  heading = "Heading",
  subHeading,
  gTagEventSponsor,
  gTagEventCategory,
  target = "_blank",
  link,
  desktopImageAnimated,
  mobileImageAnimated
}: BannerProps) => {
  const ctaAlignmentFlag =
    ctaAlignment && ctaAlignment.toLocaleLowerCase() == "right";
  const logoAlignmentFlag =
    logoAlignment && logoAlignment.toLocaleLowerCase() == "right";
  return (
    <div className="commercial-banner version__3">
      <a
        href={link && link.url}
        target={target}
        className="commercial-banner__pod"
      >
        <div
          onClick={() => {
            if (gTagEventSponsor) {
              // @ts-ignore
              dataLayer.push({
                event: "ad_banner_click",
                sponsor: gTagEventSponsor,
                category: gTagEventCategory
              });
            }
          }}
          className="commercial-banner__image"
        >
          <img
            className="commercial-banner__image--desktop"
            src={desktopImageAnimated ? desktopImageAnimated : imgDesktopURL}
          />
          <img
            className="commercial-banner__image--mobile"
            src={mobileImageAnimated ? mobileImageAnimated : imgMobileURL}
          />
          <div
            className={`commercial-banner__text${
              sponsorLogoUrl ? " branding-logo" : ""
            }${
              ctaAlignmentFlag && !sponsorLogoUrl
                ? " cta-align--right-f"
                : ctaAlignmentFlag
                ? " cta-align--right"
                : ""
            }${logoAlignmentFlag ? " logo-align--right" : ""}`}
          >
            {sponsorLogoUrl ? (
              <img
                src={`${sponsorLogoUrl}`}
                className="commercial-banner__brand-logo"
              />
            ) : null}
            <div>
              <div className="commercial-banner__title-sub">{heading}</div>
              {subHeading ? (
                <div className="commercial-banner__title">{subHeading}</div>
              ) : null}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Banner;
